import { render, staticRenderFns } from "./index.vue?vue&type=template&id=57b7df3c&scoped=true"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=57b7df3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b7df3c",
  null
  
)

export default component.exports